const ChallengePositions = {
  FIRST: "first",
  LAST: "last"
};

module.exports = ChallengePositions;
